import { list } from "./nationalityData";
export default `
<select placeholder="Country of residence" class="form-select mb-3" aria-label="Country of residence" id="countryOfResidenceCode" name="countryOfResidenceCode">
<option disabled selected hidden value="">Country of residence</option>
${list
  .map(
    ({ countryLabel, code }) =>
      `<option value="${code}">${countryLabel}</option>`
  )
  .join("")}</select>
`;
